import React from "react";
import "./PrivacyPolicy.css";
import PublicHeader from "../../components/public/PublicHeader";
import PublicFooter from "../../components/public/PublicFooter";

const Terms = () => {
    return (
        <div className="privacy-page">
            <PublicHeader />
            <section className="public-hero">
                <div className="privacy-container">
                    <h1 className="privacy-title">Zinea Terms & Conditions</h1>
                    <p><strong>Effective Date:</strong> August 9, 2024</p>
                </div>
            </section>
            <div className="privacy-container">
                <div className="privacy-content">

                    <p>By using Zinea, you agree to these Terms & Conditions. Please read them carefully.</p>

                    <h2>1. Acceptance of Terms</h2>
                    <p>By accessing or using our app and services, you agree to comply with and be bound by these terms.</p>

                    <h2>2. Use of the App</h2>
                    <p>2.1 You must be at least 13 years old to use the app.<br />
                        2.2 You agree to use the app only for lawful purposes and in a way that does not violate the rights of others.</p>

                    <h2>3. Accounts & Security</h2>
                    <p>3.1 You are responsible for maintaining the confidentiality of your account credentials.<br />
                        3.2 You agree to notify us immediately of any unauthorized use of your account.</p>

                    <h2>4. Intellectual Property</h2>
                    <p>All content, features, and functionality are the exclusive property of Zinea and its licensors. You may not use our brand, logo, or content without permission.</p>

                    <h2>5. User Content</h2>
                    <p>5.1 You retain ownership of content you create and submit.<br />
                        5.2 By submitting content, you grant Zinea a worldwide, royalty-free license to use, display, and distribute that content as part of the app.</p>

                    <h2>6. Prohibited Activities</h2>
                    <p>Do not misuse Zinea for spamming, harassment, harmful conduct, illegal activities, or infringement of intellectual property.</p>

                    <h2>7. Termination</h2>
                    <p>We reserve the right to terminate or suspend your access to the app at any time, without notice, for conduct that violates these Terms or is harmful to other users or us.</p>

                    <h2>8. Disclaimers & Limitation of Liability</h2>
                    <p>The app is provided on an "as is" basis without warranties of any kind. Zinea is not liable for any damages arising from use or inability to use the app.</p>

                    <h2>9. Changes to Terms</h2>
                    <p>We may update these Terms. Continued use means acceptance of updated terms.</p>

                    <h2>10. Governing Law</h2>
                    <p>These Terms are governed by the laws of India.</p>

                    <h2>11. Contact Us</h2>
                    <p><strong>Email:</strong> <a href="mailto:connect@zinea.app">connect@zinea.app</a></p>
                    <p><strong>Address:</strong> Zinea Lifestyles, Sector 58, Gurgaon, India</p>
                </div>
            </div>
            <PublicFooter />
        </div>
    );
};

export default Terms;
